export default "__VITE_ASSET__fNScDPgi__"